import { render } from "./Metrics.vue?vue&type=template&id=53251dce&scoped=true"
import script from "./Metrics.vue?vue&type=script&lang=js"
export * from "./Metrics.vue?vue&type=script&lang=js"

import "./Metrics.vue?vue&type=style&index=0&id=53251dce&scoped=true&lang=less"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53251dce"]])

export default __exports__